import React__default from 'react';
import TestSelectionList from './TestSelectionList.esm.js';

var CompactTestSelection = function (_a) {
    var handleDeleteTest = _a.handleDeleteTest, productType = _a.productType, testSelections = _a.testSelections;
    return (React__default.createElement(TestSelectionList, { handleDeleteTest: handleDeleteTest, isCompact: true, productType: productType, testSelections: testSelections }));
};

export { CompactTestSelection as default };
//# sourceMappingURL=CompactTestSelection.esm.js.map
